import {filterFlyoutIconAssets} from '../../molecules/Filters/assets';
import {pushNotificationIconAssets} from '../../molecules/PushNotification/assets';
import {storeBadgeIconAssets} from '../../molecules/StoreBadge/assets';
import {wishlistIconAssets} from '../../molecules/WishButton/assets';
import {logoIconAssets} from '../../organisms/AboutYouMainLogo/assets';
import {footerIconAssets} from '../../organisms/ContactLinks/assets';
import {headerIconAssets} from '../../organisms/Header/assets';
import {backButtonIconAssets} from '../BackButton/assets';
import {errorPageInlineIconAssets} from '../ErrorPageInline/assets';
import {filterIconAssets} from '../FilterToggleButton/assets';
import {sustainabilityIconAssets} from '../SustainabilityIcon/assets';
import {transparentLogoIconAssets} from '../TransparentLogo/assets';
import {basketIconAssets} from './Basket/basketIconAssets';
import {GenericIconName} from './IconName';
import {wishlistPageIconAssets} from './Wishlist/wishlistPageIconAssets';

export const sharedIconAssets = {
  [GenericIconName.CouponNav]: require('./assets/svgs/ic-coupon-nav.svg'),
  [GenericIconName.CheckmarkSmall]: require('./assets/svgs/ic-checkmark-small.svg'),
  [GenericIconName.AboutYouKnob]: require('./assets/svgs/ic-aboutyou-knob.svg'),
  [GenericIconName.AddCircleFill]: require('./assets/svgs/ic-add-circle-fill.svg'),
  [GenericIconName.ArrowUp]: require('./assets/svgs/ic-arrow-up.svg'),
  [GenericIconName.ArrowDown]: require('./assets/svgs/ic-arrow-down.svg'),
  [GenericIconName.ArrowLeft]: require('./assets/svgs/ic-arrow-left.svg'),
  [GenericIconName.ArrowLongRight]: require('./assets/svgs/ic-arrow-long-right.svg'),
  [GenericIconName.ArrowRight]: require('./assets/svgs/ic-arrow-right.svg'),
  [GenericIconName.ArrowSmallRight]: require('./assets/svgs/ic-arrow-small-right.svg'),
  [GenericIconName.Chatbot]: require('./assets/svgs/ic-chatbot.svg'),
  [GenericIconName.Checkmark]: require('./assets/svgs/ic-checkmark.svg'),
  [GenericIconName.CheckmarkCircle]: require('./assets/svgs/ic-checkmark-circle.svg'),
  [GenericIconName.CheckmarkCircleWhiteCheck]: require('./assets/svgs/ic-checkmark-circle-white-check.svg'),
  [GenericIconName.ChevronDown]: require('./assets/svgs/ic-chevron-down.svg'),
  [GenericIconName.Coins]: require('./assets/svgs/ic-coins.svg'),
  [GenericIconName.CoinsIconDark]: require('./assets/svgs/ic-coins-dark.svg'),
  [GenericIconName.Coupons]: require('./assets/svgs/ic-coupons.svg'),
  [GenericIconName.CouponCloud]: require('./assets/svgs/ic-coupon-cloud.svg'),
  [GenericIconName.Dropdown]: require('./assets/svgs/ic-dropdown.svg'),
  [GenericIconName.FlagReport]: require('./assets/svgs/ic-flag-report.svg'),
  [GenericIconName.Heart]: require('./assets/svgs/ic-heart.svg'),
  [GenericIconName.HeartAdd]: require('./assets/svgs/ic-heart-add.svg'),
  [GenericIconName.HeartFilled]: require('./assets/svgs/ic-heart-filled.svg'),
  [GenericIconName.Locked]: require('./assets/svgs/ic-locked.svg'),
  [GenericIconName.Share]: require('./assets/svgs/ic-share.svg'),
  [GenericIconName.ShareAndroid]: require('./assets/svgs/ic-share-android.svg'),
  [GenericIconName.AddToBasket]: require('./assets/svgs/ic-add-to-basket.svg'),
  [GenericIconName.AddToBasketFilled]: require('./assets/svgs/ic-add-to-basket-filled.svg'),
  [GenericIconName.NavBasket]: require('./assets/svgs/ic-nav-basket.svg'),
  [GenericIconName.NavHeaderBasket]: require('./assets/svgs/ic-nav-header-basket.svg'),
  [GenericIconName.NavHeaderWishlist]: require('./assets/svgs/ic-nav-header-wishlist.svg'),
  [GenericIconName.NavHeaderSearch]: require('./assets/svgs/ic-nav-header-search.svg'),
  [GenericIconName.NavUser]: require('./assets/svgs/ic-nav-user.svg'),
  [GenericIconName.GridSingleCol]: require('./assets/svgs/ic-grid-single-col.svg'),
  [GenericIconName.GridMultiCol]: require('./assets/svgs/ic-grid-multi-col.svg'),
  [GenericIconName.Search]: require('./assets/svgs/ic-search.svg'),
  [GenericIconName.Info]: require('./assets/svgs/ic-info.svg'),
  [GenericIconName.InfoFill]: require('./assets/svgs/ic-info-fill.svg'),
  [GenericIconName.InfoFilled]: require('./assets/svgs/info-serif.svg'),
  [GenericIconName.InfoSponsored]: require('./assets/svgs/sponsored-icon.svg'),
  [GenericIconName.InfoWithoutFill]: require('./assets/svgs/info-serif-without-fill.svg'),
  [GenericIconName.InfoFilledGray]: require('./assets/svgs/ic-info-gray.svg'),
  [GenericIconName.InfoSquaredGray]: require('./assets/svgs/ic-info-squared-gray.svg'),
  [GenericIconName.Close]: require('./assets/svgs/ic-close.svg'),
  [GenericIconName.Download]: require('./assets/svgs/ic-download.svg'),
  [GenericIconName.Error]: require('./assets/svgs/ic-warning-fill.svg'),
  [GenericIconName.EmptySearch]: require('./assets/svgs/ic-empty-search.svg'),
  [GenericIconName.ExternalLink]: require('./assets/svgs/ic-external-link.svg'),
  [GenericIconName.ExternalLinkBordered]: require('./assets/svgs/ic-external-link-bordered.svg'),
  [GenericIconName.AlertSuccess]: require('./assets/svgs/ic-alert-success.svg'),
  [GenericIconName.AlertSuccessFill]: require('./assets/svgs/ic-success-fill.svg'),
  [GenericIconName.AlertErrorFill]: require('./assets/svgs/ic-error-fill.svg'),
  [GenericIconName.AlertErrorCircleFill]: require('./assets/svgs/ic-error-circle-fill.svg'),
  [GenericIconName.Discount]: require('./assets/svgs/ic-discount.svg'),
  [GenericIconName.Vip]: require('./assets/svgs/ic-vip.svg'),
  [GenericIconName.AlertError]: require('./assets/svgs/ic-alert-error.svg'),
  [GenericIconName.Clock]: require('./assets/svgs/ic-clock.svg'),
  [GenericIconName.Globe]: require('./assets/svgs/ic-globe.svg'),
  [GenericIconName.Reset]: require('./assets/svgs/ic-reset.svg'),
  [GenericIconName.DoubleArrow]: require('./assets/svgs/ic-double-arrow.svg'),
  [GenericIconName.ParcelBox]: require('./assets/svgs/ic-parcel.svg'),
  [GenericIconName.Ruler]: require('./assets/svgs/ic-ruler.svg'),
  [GenericIconName.UspProofOfQuality]: require('./assets/svgs/ic-usp-proof-of-quality.svg'),
  [GenericIconName.List]: require('./assets/svgs/ic-list.svg'),
  [GenericIconName.Warning]: require('./assets/svgs/ic-warning.svg'),
  [GenericIconName.WarningFill]: require('./assets/svgs/ic-warning-fill.svg'),
  [GenericIconName.USPReturn]: require('./assets/svgs/ic-usp-return.svg'),
  [GenericIconName.More]: require('./assets/svgs/ic-more.svg'),
  [GenericIconName.Trash]: require('./assets/svgs/ic-trash.svg'),
  [GenericIconName.Hashtag]: require('./assets/svgs/ic-hashtag.svg'),
  [GenericIconName.Mail]: require('./assets/svgs/ic-mail.svg'),
  [GenericIconName.Size]: require('./assets/svgs/ic-size.svg'),
  [GenericIconName.SaleEvent]: require('./assets/svgs/ic-sale-event.svg'),
  [GenericIconName.SmallSaleEvent]: require('./assets/svgs/ic-small-sale-event.svg'),
  [GenericIconName.Phone]: require('./assets/svgs/ic-phone.svg'),
  [GenericIconName.SocialWhatsapp]: require('./assets/svgs/ic-social-whatsapp.svg'),
  [GenericIconName.MailBlack]: require('./assets/svgs/ic-mail-black.svg'),
  [GenericIconName.User]: require('./assets/svgs/ic-user.svg'),
  [GenericIconName.SmileyHappy]: require('./assets/svgs/ic-smiley-happy.svg'),
  [GenericIconName.SmileySad]: require('./assets/svgs/ic-smiley-sad.svg'),
  [GenericIconName.QuestionMark]: require('./assets/svgs/ic-question.svg'),
  [GenericIconName.Sale]: require('./assets/svgs/ic-sale.svg'),
  [GenericIconName.SecondHandService]: require('./assets/svgs/ic-secondhand-service.svg'),
  [GenericIconName.Percent]: require('./assets/svgs/ic-percent.svg'),
  [GenericIconName.FullscreenOpener]: require('./assets/svgs/ic-fullscreen-opener.svg'),
  [GenericIconName.Pause]: require('./assets/svgs/ic-pause.svg'),
  [GenericIconName.Play]: require('./assets/svgs/ic-play.svg'),
  [GenericIconName.Mute]: require('./assets/svgs/ic-mute.svg'),
  [GenericIconName.Unmute]: require('./assets/svgs/ic-unmute.svg'),
  [GenericIconName.YourFiltersHint]: require('./assets/svgs/ic-your-filters-hint.svg'),
  [GenericIconName.StarFilled]: require('./assets/svgs/ic-star-fill.svg'),
  [GenericIconName.FitAdvisor]: require('./assets/svgs/ic-fit-advisor.svg'),
  [GenericIconName.FacebookIcon]: require('./assets/svgs/ic-facebook.svg'),
  [GenericIconName.AppleIcon]: require('./assets/svgs/ic-apple.svg'),
  [GenericIconName.SearchHistory]: require('./assets/svgs/ic-history.svg'),
  [GenericIconName.SaleCloud]: require('./assets/svgs/ic-sale-cloud.svg'),
  [GenericIconName.SaleCloudRTL]: require('./assets/svgs/ic-sale-cloud-rtl.svg'),
  [GenericIconName.Bell]: require('./assets/svgs/ic-bell-plus.svg'),
  [GenericIconName.BellFilled]: require('./assets/svgs/ic-bell-plus-filled.svg'),
  [GenericIconName.DropdownUpRight]: require('./assets/svgs/ic-dropdown-up-right.svg'),
  [GenericIconName.UspFreeShipping]: require('./assets/svgs/ic-usp-free-shipping.svg'),
  [GenericIconName.Lock]: require('./assets/svgs/ic-lock.svg'),
  [GenericIconName.Settings]: require('./assets/svgs/ic-settings.svg'),
  [GenericIconName.Help]: require('./assets/svgs/ic-chat.svg'),
  [GenericIconName.CreditCard]: require('./assets/svgs/ic-credit-card.svg'),
  [GenericIconName.StarOutline]: require('./assets/svgs/ic-star-outline.svg'),
  [GenericIconName.Coupon]: require('./assets/svgs/ic-coupon.svg'),
  [GenericIconName.Merchant]: require('./assets/svgs/ic-merchant.svg'),
  [GenericIconName.NotificationCenterEmptyState]: require('./assets/svgs/notificationCenterEmptyStateImg.svg'),
  [GenericIconName.BestPriceGuaranteeWallet]: require('./assets/svgs/ic-bpg-icon.svg'),
  [GenericIconName.Loudspeaker]: require('./assets/svgs/ic-loudspeaker.svg'),
  [GenericIconName.SustainabilityLeaf]: require('./assets/svgs/ic-sustainability-icon.svg'),
  [GenericIconName.InfoOutline]: require('./assets/svgs/ic-info-outline.svg'),
  [GenericIconName.AppOnlyCoupon]: require('./assets/svgs/ic-app-only-coupon.svg'),
  [GenericIconName.AppOnlyIcon]: require('./assets/svgs/ic-app-only.svg'),
  [GenericIconName.ArrowUpSharpCorners]: require('./assets/svgs/ic-arrow-up-sharp-corners.svg'),
  [GenericIconName.CouponExpired]: require('./assets/svgs/ic-coupon-expired.svg'),
  [GenericIconName.ErrorTriangle]: require('./assets/svgs/ic-error-triangle.svg'),
  [GenericIconName.AddToBasketWithCheckMark]: require('./assets/svgs/ic-add-to-basket-with-check-mark.svg'),
  [GenericIconName.PauseRound]: require('./assets/svgs/ic-pause-round.svg'),
  [GenericIconName.RightArrowSharpEdges]: require('./assets/svgs/ic-right-arrow-sharp-edges.svg'),
  [GenericIconName.ErrorTriangleColor]: require('./assets/svgs/ic-error-triangle-color.svg'),
  [GenericIconName.couponHintCloud]: require('./assets/svgs/ic-coupon-hint-cloud.svg'),
  [GenericIconName.copy]: require('./assets/svgs/ic-copy.svg'),
  [GenericIconName.Unlocked]: require('./assets/svgs/ic-unlocked.svg'),
  [GenericIconName.UnlockedFilled]: require('./assets/svgs/ic-unlocked-filled.svg'),
  [GenericIconName.CoinsStriped]: require('./assets/svgs/ic-coins-striped.svg'),
  [GenericIconName.CoinsFilled]: require('./assets/svgs/ic-coins-filled.svg'),
  [GenericIconName.CoinsDoubleColor]: require('./assets/svgs/ic-coins-double-color.svg'),
  [GenericIconName.CoinsDoubleColorSuccess]: require('./assets/svgs/ic-coins-double-color-success.svg'),
  [GenericIconName.BasketLock]: require('./assets/svgs/ic-basket-lock.svg'),
  [GenericIconName.LongArrow]: require('./assets/svgs/ic-long-arrow.svg'),
  [GenericIconName.CrossFill]: require('./assets/svgs/ic-cross-fill.svg'),
  [GenericIconName.CheckmarkBorder]: require('./assets/svgs/ic-checkmark-border.svg'),
  [GenericIconName.PlayOutline]: require('./assets/svgs/ic-play-outline.svg'),
  [GenericIconName.DropsSneaker]: require('./assets/svgs/ic-drops-sneaker.svg'),
  [GenericIconName.PriceInfo]: require('./assets/svgs/ic-price-info.svg'),
  [GenericIconName.Grabber]: require('./assets/svgs/ic-grabber.svg'),
  [GenericIconName.Confetti]: require('./assets/svgs/ic-confetti.svg'),
  [GenericIconName.OpenedBox]: require('./assets/svgs/ic-opened-box.svg'),
  [GenericIconName.Shirts]: require('./assets/svgs/ic-shirts.svg'),
  [GenericIconName.Spinner]: require('./assets/svgs/ic-spinner.svg'),
  ...filterIconAssets,
  ...filterFlyoutIconAssets,
  ...sustainabilityIconAssets,
  ...wishlistIconAssets,
  ...errorPageInlineIconAssets,
  ...headerIconAssets,
  ...logoIconAssets,
  ...footerIconAssets,
  ...basketIconAssets,
  ...backButtonIconAssets,
  ...transparentLogoIconAssets,
  ...pushNotificationIconAssets,
  ...storeBadgeIconAssets,
  ...wishlistPageIconAssets,
} as const;
